import { ActivatedRouteSnapshot, ResolveFn, Route } from '@angular/router';
import { KIDS_TERMIN_PATH } from '../../../mgs-path-defs';
import { mgsIconsResolver } from '../../../mgs-svg-icon.helper';
import { mgsAuthenticatedGuard, mgsKidsGuard } from '../../../mgs-guards';
import { inject } from '@angular/core';
import { KidsTerminService } from './kids-termin.service';
import { KidsTermineStore } from '../kids-termine.store';
import { kidsDatenResolver } from '../../kids-daten.resolver';

export const kidsTerminResolver: ResolveFn<void> = async (route: ActivatedRouteSnapshot) => {
  const kidsTerminService = inject(KidsTerminService);
  const terminStore = inject(KidsTermineStore);

  await terminStore.load();

  const terminId = +route.params['terminId'];

  await kidsTerminService.load(terminId);
};

export const kidsTerminRoute: Route = {
  path: KIDS_TERMIN_PATH + '/:terminId',
  title: 'Kids Termin',
  loadComponent: () => import('./kids-termin.component').then((c) => c.KidsTerminComponent),
  canActivate: [mgsAuthenticatedGuard, mgsKidsGuard],
  resolve: { kidsTermin: kidsTerminResolver, kidsDaten: kidsDatenResolver, icons: mgsIconsResolver }
};
